import { CircularProgress } from "@mui/joy";
import { useGetDealInformationByIdQuery } from "../../../../api/dealApi";
import { Deal } from "../../../../types/pipeline";
import { ErrorMessage } from "../../../../components/errors/ErrorMessage";
import { DealDetails } from "../../DealDetails/DealDetails";
import { VisitaDetails } from "../../../visitas/VisitaDetails/components/VisitaDetails";
import { useMemo, useState } from "react";
import { FinishVisitaForm } from "../../../visitas/FinishVisita/FinishVisitaForm";
import { Link, useLocation } from "react-router";
import { AddVisitFromDealInformation } from "../../../visitas/RegisterVisita/AddVisitFromDealInformation";

export type CurrentComponent = {
    component: "Deal" | "Visita" | "FinishVisita" | "RegisterVisitaForm";
    visitaId: null | number;
};

interface Props {
    deal: Deal;
}

export function DealInformation({ deal }: Props) {
    const location = useLocation();

    const { data, isLoading, isFetching, isError, isSuccess } = useGetDealInformationByIdQuery(deal.id);

    const [currentComponent, setCurrentComponent] = useState<CurrentComponent>({ component: "Deal", visitaId: null });

    const component = useMemo(() => {
        if(data == undefined)
            return;

        if(currentComponent.visitaId == null)
            return <DealDetails
                        deal={data}
                        setCurrentComponent={setCurrentComponent} />;

        switch (currentComponent.component) {
            case "Deal":  
                return <DealDetails
                        deal={data}
                        setCurrentComponent={setCurrentComponent} />;

            case "Visita": 
                return <VisitaDetails
                            visitaId={currentComponent.visitaId}
                            onFinish={() => setCurrentComponent({ component: "FinishVisita", visitaId: currentComponent.visitaId })}
                            onCancel={()=> setCurrentComponent({ component: "Deal", visitaId: null })} />;

            case "FinishVisita":
                return <FinishVisitaForm
                            visitaId={currentComponent.visitaId}
                            setCurrentComponent={setCurrentComponent} />;
            
            case "RegisterVisitaForm": 
                return <AddVisitFromDealInformation
                            tipoVisitaId={1}
                            dealId={deal.id}
                            setCurrentComponent={setCurrentComponent}/>;
            
            default: 
                return <DealDetails
                    deal={data}
                    setCurrentComponent={setCurrentComponent} />;
        }
    }, [currentComponent, data])

    if(isLoading || isFetching)
        return (
        <div className="h-[600px] flex justify-center items-center p-3">
            <CircularProgress />
        </div>
        );
    
    if(isError || !isSuccess)
        return(
        <ErrorMessage>
            Algo fallo
        </ErrorMessage>
    );

    return (
        <div className="flex flex-col p-3 w-full h-[700px] overflow-hidden">
            <p className="text-xl font-semibold pb-3">
                Campaña con la empresa <Link
                    className="w-fit" 
                    to={`/empresa/${deal.empresaId}`}
                    state={{ fromName: "embudo", fromPath: location.pathname }}>
                    <span>{deal.nombreEmpresa}</span>
                </Link>
            </p>
            {component}
        </div>
    );
}
